import React, { Component, Fragment } from "react";
import api from "../../../services/api";
import "./styles.css";
import ModalAlert from "../../common/modal-alert";
import ModalConfirm from "../../common/modal-confirm";
import Moment from "react-moment";
import moment from "moment";
import * as CONSTANTS from "../../../services/constants";
import DropMonthYear from "../../../components/DropMonthYear";
import EmployeeForm from "../../employees/employees-create/EmployeeForm";
import Toast from "../../../components/Toast";
import { browserHistory } from 'react-router'


// Set the timezone for every instance.
Moment.globalTimezone = "UTC";

class Company extends Component {
  state = {
    load: false,
    documentsToUpload: {},
    documentsToUploadPeriodic: {},
    employeeDocuments: {},
    employeeDocumentsPeriodic: {},
    erroDelete: false,
    dataEmployee: {},
    employeeStatusId: null,
    typeAttach: "",
    showDocs: true,
    showDocsPeriodic: true,
    isValidadeCalendar: true,
    titleDocumentValidate: null,
    idDocumentValidate: null,
    sectorDocumentsRelation: {},
    sectorDocumentsRelationPeriodic: {},
    year: moment().format("YYYY"),
    month: CONSTANTS.months()[CONSTANTS.currMonth()],
    openModal: false,
    sectors: null,
    functions: null,
    msgError: null,
    msgSuccess: null,
    repostType:'employee',
    user_sector:localStorage.getItem("SectorId"),
    toastRender: false,
    toastRenderError: false,
    toastView: false,
    timer:false,
    historicalDocuments: [],
    showHistoricalDocs: false,
    bulkApprovalMode: false,
    selectedDocuments: [],
    showBulkApproveButton: false,
    lostFiles: [],
    showLostFiles: false,
    expandedCategories: {
      'Outros pertinentes à função': false // Set Outros category to be expanded by default
    },
    documentCategories: JSON.parse(process.env.REACT_APP_DOCUMENT_CATEGORIES || '[]'),
    employeeDocumentCategories: JSON.parse(process.env.REACT_APP_EMPLOYEE_DOCUMENT_CATEGORIES || '{}'),
  };

  async componentDidMount() {
    await this.searchDataEmployee();
    await this.searchDocumentsEmployee();
    await this.searchDocumentsToEmployee();
    await this.searchSectors();
    await this.searchFunctions();
  }

  updateEmployee = async newData => {
    this.setState({ load: true, msgError: null, msgSuccess: null });
    await api
      .patch(`/employees/${newData.id}/data`, newData)
      .then(async res => {
        await this.searchDataEmployee();
        this.setState({ load: false, msgError: null });
        document.getElementById("closeModal").click();
        document.getElementById("modal-alert").click();
        this.setState({
          msgAlert: res.data.msg,
          classText: "text-success",
          openModal: false
        });
      })
      .catch(({ response }) => {
        this.setState({ msgError: response.data.msg, load: false });
      });
    // }
  };

  searchSectors = async () => {
    this.setState({ load: true });
    const response = await api.get(`/sectors?status=1`);
    this.setState({ sectors: response.data.rows, load: false });
  };

  searchFunctions = async () => {
    this.setState({ load: true });
    const response = await api.get(`/functions?order_by=description`);
    this.setState({ functions: response.data.rows, load: false });
  };

  searchDataEmployee = async () => {
    const dataEmployee = await api.get(
      `/employees/${this.props.match.params.id}`
    );
    console.log("TCL: searchDataEmployee -> dataEmployee", dataEmployee);
    this.setState({
      dataEmployee: dataEmployee.data,
      EmployeeStatus: dataEmployee.data.EmployeeStatus.description
    });
  };

  searchDocumentsEmployee = async () => {
    const { month, year } = this.state;
    if (this.state.dataEmployee) {
      await api
        .get(
          `/employees/${this.props.match.params.id}/attachments?DocumentTypeId=3`
        )
        .then(result => {
          this.setState({
            employeeDocuments: result.data.rows
          });
        });

      await api
        .get(
          `/employees/${this.props.match.params.id}/attachments?DocumentTypeId=4&year=${year}&month=${month}`
        )
        .then(result => {
          this.setState({
            employeeDocumentsPeriodic: result.data.rows
          });
        });
    }
  };

  searchDocumentsToEmployee = async () => {
    if (!this.state.dataEmployee || !this.state.dataEmployee.Function) {
      console.log("Employee data or Function not loaded yet");
      return;
    }

    const functionId = this.state.dataEmployee.Function.id;
    const companyTypeDocuments = await api.get(
      `/company-types/${this.props.match.params.companyid}/documents?DocumentTypeId=3&FunctionId=${functionId}`
    );
    console.log(
      "DOCUMENTOS CADASTRAIS QUE PRECISAM SER ENVIADOS",
      companyTypeDocuments.data.data.length
    );
    const companyTypeDocumentsPeriodic = await api.get(
      `/company-types/${this.props.match.params.companyid}/documents?DocumentTypeId=4`
    );
    console.log(
      "DOCUMENTOS MENSAIS QUE PRECISAM SER ENVIADOS",
      companyTypeDocumentsPeriodic.data.data.length
    );
    this.setState({
      documentsToUpload: companyTypeDocuments.data.data,
      documentsToUploadPeriodic: companyTypeDocumentsPeriodic.data.data
    });
    this.searchSectorDocumentsRelation();
    // this.sendApproval();
    this.verifyStatusEmployee();
  };

  searchSectorDocumentsRelation = async () => {
    const user_sector = localStorage.getItem("SectorId");
    const sectorDocumentsRelation = await api.get(
      `/sectors/${user_sector}/documents?DocumentTypeId=3`
    );
    const sectorDocumentsRelationPeriodic = await api.get(
      `/sectors/${user_sector}/documents?DocumentTypeId=4`
    );
    console.log("PESQUISA DOS TIPOS DE DOCUMENTOS");
    console.log(sectorDocumentsRelation.data.data);
    console.log(sectorDocumentsRelationPeriodic.data.data);

    if (sectorDocumentsRelation.data.data.length > 0) {
      this.setState({
        sectorDocumentsRelation: sectorDocumentsRelation.data.data
      });
    }

    if (sectorDocumentsRelationPeriodic.data.data.length > 0) {
      this.setState({
        sectorDocumentsRelationPeriodic:
          sectorDocumentsRelationPeriodic.data.data
      });
    }
  };

  verifyDocument = (id, list) => {
    const exist = list.filter(item => item.DocumentId == id);
    return exist.length > 0 ? exist[0].originalName : "";
  };

  verifyDocumentYear = (id, list) => {
    if (list.length) {
      const exist = list.filter(item => item.DocumentId == id);
      return exist.length > 0 ? exist[0].year : "";
    }
  };

  verifyDocumentMonth = (id, list) => {
    if (list.length) {
      const exist = list.filter(item => item.DocumentId == id);
      return exist.length > 0 ? exist[0].month : "";
    }
  };

  validateDocument = (e, list) => {
    this.setState({ load: false, msgError: null });
    document.getElementById("data_integracao").value = "";

    let attachments = list.filter(i => i.DocumentId == e.target.id);

    console.log(attachments);

    this.setState({
      titleDocumentValidate: attachments[0].Document.description,
      idAttachment: attachments[0].id,
      idAttachmentValidateStatus: attachments[0].AttachmentStatus.id,
      updateDate: false
    });
  };

  confirmRepostFile = async (e, list, type) => {
    let attach = list.filter(item => item.DocumentId == e.target.id);
    this.setState({repostType:type});
    this.setState({
      msgError: null,
      idAttachment: attach[0].id,
      typeAttach: e.target.name
    });
    document.getElementById("modal-repost").click();
  };

  updateDateDocument = async e => {
    const validityDate = document.getElementById("data_integracao").value;
    if (!validityDate) {
      this.setState({ msgError: "Selecione uma data!" });
      return;
    } else {
      this.setState({ msgError: "" });
      await api
        .patch(
          `/employees/${this.props.match.params.id}/attachmentsvalidity/${this.state.idAttachment}`,
          {
            validityDate: validityDate,
            AttachmentStatusId: this.state.idAttachmentValidateStatus
          }
        )
        .then(async result => {
          this.setState({ load: false, msgError: null });
          document.getElementById("closeModal").click();
          document.getElementById("modal-alert").click();
          this.setState({
            msgAlert: result.data.msg,
            classText: "text-success"
          });

          await this.searchDocumentsEmployee();
          await this.searchDocumentsToEmployee();
        })
        .catch(err => {
          if (err) {
            this.setState({ msgError: err.msg, classText: "text-danger" });
          } else {
            this.setState({
              msgError: "Erro no processamento. Tente novamente!",
              classText: "text-danger"
            });
          }
        });
    }
  };

  showValidityDate = (item, list) => {
    var validityDate = [];

    if ('DocumentToCompanyTypes' in item) 
      validityDate = item.DocumentToCompanyTypes;
    else 
      validityDate.push(item.Functions[0].DocumentToFunctions);

    var validity = false;
    if (list.length) {
      var attachments = list.filter(
        i => i.DocumentId == validityDate[0].DocumentId
      );

      if (attachments.length) {
        validity = attachments[0].validityDate
          ? attachments[0].validityDate
          : false;
      }
    }

    if (
      this.verifyFileApproval(validityDate[0].DocumentId) &&
      this.verifyFile(validityDate[0].DocumentId, list)
    ) {
      if (validity) {
        return (
          <div>
            <Moment format="DD/MM/YYYY">{validity}</Moment>
            <button
              type="button"
              id={validityDate[0].DocumentId}
              onClick={e => this.validateDocument(e, list)}
              data-toggle="modal"
              data-target=".modal-validade-date"
              title="Alterar data de validade"
              className="btn btn-sm btn-outline-info btn-circle"
            >
              <i id={validityDate[0].DocumentId} className="fa fa-calendar" />
            </button>
          </div>
        );
      } else {
        try {
          let validity = validityDate[0].defaultValidity.split("-");
          switch (validity[1]) {
            case "years":
              return (
                <div>
                  <Moment add={{ years: validity[0] }} format="DD/MM/YYYY">
                    {validityDate[0].createdAt}
                  </Moment>
                  <button
                    type="button"
                    id={validityDate[0].DocumentId}
                    onClick={e => this.validateDocument(e, list)}
                    data-toggle="modal"
                    data-target=".modal-validade-date"
                    title="Alterar data de validade"
                    className="btn btn-sm btn-outline-info btn-circle"
                  >
                    <i
                      id={validityDate[0].DocumentId}
                      className="fa fa-calendar"
                    />
                  </button>
                </div>
              );
              break;
            case "months":
              return (
                <div>
                  <Moment add={{ months: validity[0] }} format="DD/MM/YYYY">
                    {validityDate[0].createdAt}
                  </Moment>
                  <button
                    type="button"
                    id={validityDate[0].DocumentId}
                    onClick={e => this.validateDocument(e, list)}
                    data-toggle="modal"
                    data-target=".modal-validade-date"
                    title="Alterar data de validade"
                    className="btn btn-sm btn-outline-info btn-circle"
                  >
                    <i
                      id={validityDate[0].DocumentId}
                      className="fa fa-calendar"
                    />
                  </button>
                </div>
              );
              break;
            case "weeks":
              return (
                <div>
                  <Moment add={{ weeks: validity[0] }} format="DD/MM/YYYY">
                    {validityDate[0].createdAt}
                  </Moment>
                  <button
                    type="button"
                    id={validityDate[0].DocumentId}
                    onClick={e => this.validateDocument(e, list)}
                    data-toggle="modal"
                    data-target=".modal-validade-date"
                    title="Alterar data de validade"
                    className="btn btn-sm btn-outline-info btn-circle"
                  >
                    <i
                      id={validityDate[0].DocumentId}
                      className="fa fa-calendar"
                    />
                  </button>
                </div>
              );
              break;
            case "days":
              return (
                <div>
                  <Moment add={{ days: validity[0] }} format="DD/MM/YYYY">
                    {validityDate[0].createdAt}
                  </Moment>{" "}
                  <button
                    type="button"
                    id={validityDate[0].DocumentId}
                    onClick={e => this.validateDocument(e, list)}
                    data-toggle="modal"
                    data-target=".modal-validade-date"
                    title="Alterar data de validade"
                    className="btn btn-sm btn-outline-info btn-circle"
                  >
                    <i
                      id={validityDate[0].DocumentId}
                      className="fa fa-calendar"
                    />
                  </button>
                </div>
              );
              break;
            default:
              break;
          }
        } catch (error) {
          return (
            <div>
              Indefinida{" "}
              <button
                type="button"
                id={validityDate[0].DocumentId}
                onClick={e => this.validateDocument(e, list)}
                data-toggle="modal"
                data-target=".modal-validade-date"
                title="Alterar data de validade"
                className="btn btn-sm btn-outline-info btn-circle"
              >
                <i id={validityDate[0].DocumentId} className="fa fa-calendar" />
              </button>{" "}
            </div>
          );
        }
      }
    } else {
      if (validity) {
        return (
          <div>
            <Moment format="DD/MM/YYYY">{validity}</Moment>
          </div>
        );
      } else {
        try {
          let validity = validityDate[0].defaultValidity.split("-");
          switch (validity[1]) {
            case "years":
              return (
                <Moment add={{ years: validity[0] }} format="DD/MM/YYYY">
                  {validityDate[0].createdAt}
                </Moment>
              );
              break;
            case "months":
              return (
                <Moment add={{ months: validity[0] }} format="DD/MM/YYYY">
                  {validityDate[0].createdAt}
                </Moment>
              );
              break;
            case "weeks":
              return (
                <Moment add={{ weeks: validity[0] }} format="DD/MM/YYYY">
                  {validityDate[0].createdAt}
                </Moment>
              );
              break;
            case "days":
              return (
                <Moment add={{ days: validity[0] }} format="DD/MM/YYYY">
                  {validityDate[0].createdAt}
                </Moment>
              );
              break;
            default:
              break;
          }
        } catch (error) {
          return "Indefinida";
        }
      }
    }
  };

  verifyStatusEmployee = async () => {
    await api.get(`/employees/${this.props.match.params.id}`).then(result => {
      this.setState({ employeeStatusId: result.data.EmployeeStatusId });
    });
  };

  confirmAlterStatusEmployee = async () => {
    this.setState({ erroDelete: null });
    document.getElementById("modal-confirm").click();
  };

  alterStatusEmployee = async () => {
    this.setState({ load: true });
    await api
      .patch(`/employees/${this.props.match.params.id}`, {
        EmployeeStatusId: 5
      })
      .then(result => {
        document.getElementById("close-modal-confirm").click();
        document.getElementById("closeModal").click();
        document.getElementById("modal-alert").click();
        this.setState({ msgAlert: result.data.msg, classText: "text-success" });
        this.searchDocumentsEmployee();
        this.searchDocumentsToEmployee();
        this.setState({ load: false, erroDelete: null });
      })
      .catch(err => {
        if (err && err.response.data.errors[0]) {
          this.setState({
            msgAlert: err.response.data.errors[0].msg,
            classText: "text-danger"
          });
        } else {
          this.setState({
            msgAlert: "Erro no envio. Tente novamente!",
            classText: "text-danger"
          });
        }
      });

    this.searchDataEmployee();
  };

  verifyStatus = (id, list) => {
    if (list.length) {
      let status = list.filter(item => item.DocumentId == id);
      if (status[0]) {
        if (status[0].AttachmentStatus.id !== 1) {
          const UserName = status[0].User
            ? status[0].User.name
            : "Não informado";

          return `${status[0].AttachmentStatus.name} por : ${UserName}`;
        }
      }
    }
  };

  verifyStatusNote = (id, list) => {
    if (list.length) {
      let status = list.filter(item => item.DocumentId == id);
      if (status[0]) {
        return status[0].note;
      }
    }
  };
 
  verifyStatusExpired = (id, list) => {
    if (list.length) {
      let exist = list.filter(item => item.DocumentId == id);
      if (exist.length > 0) {
        if (exist[0].expired) {
          return "Vencido";
        }
      }
    }
  };

  verifyFile = (id, list) => {
    const status = CONSTANTS.EmployeeStatus.AprovaçãoDeDocumentos;
    console.log("=== STATUS DO DOCUMENTO ===", status);
    // if (list.length && status == this.state.employeeStatusId) {
    if (list.length) {
      const res = list.filter(item => item.DocumentId == id).length
        ? true
        : false;
      console.log("verifyFile -> res", res);
      console.log(list.filter(item => item.DocumentId == id));
      return res;
    } else {
      return false;
    }
  };
  verifyDocumentNotApplicable = (id, list) => {
    if (list.length) {
      const exist = list.filter(item => item.DocumentId == id);
      return exist.length > 0 ? exist[0].notapplicable : false;
    } else {
      return false;
    }
  };

  verifyFileApproval = id => {
    const user_sector = localStorage.getItem("SectorId");
    if (user_sector == 3) return true;

    if (this.state.sectorDocumentsRelation.length) {
      let data = this.state.sectorDocumentsRelation.filter(
        item => item.id == id
      );
      return data.length ? data[0].DocumentToSectors.approve : false;
    } else {
      return false;
    }
  };

  verifyFileApprovalPeriodic = id => {
    const user_sector = localStorage.getItem("SectorId");
    if (user_sector == 3) return true;

    if (this.state.sectorDocumentsRelationPeriodic.length) {
      let data = this.state.sectorDocumentsRelationPeriodic.filter(
        item => item.id == id
      );
      //OLD
      // return data.length ? data[0].DocumentToSectors.approve : false;
      return data.length ? true : false;
    } else {
      return false;
    }
  };

  verifyFileApprovalPeriodicSector = id => {
    const user_sector = localStorage.getItem("SectorId");
    if (user_sector == 3) return true;

    if (this.state.sectorDocumentsRelationPeriodic.length) {
      let data = this.state.sectorDocumentsRelationPeriodic.filter(
        item => item.id == id
      );
      return data.length ? data[0].DocumentToSectors.approve : false;
    } else {
      return false;
    }
  };

  downloadFile = async (e, list, isHistory = false) => {

    let data = list.filter(item => item.DocumentId == e.target.id);

    let attachId = (isHistory) ? e.target.attachId : data[0].id;

    if (data.length) {
      // document
      //   .getElementById("btn_download")
      //   .setAttribute(
      //     "href",
      //     `${process.env.REACT_APP_BASE_URL}/employees/${this.props.match.params.id}/attachments/${data[0].id}/file`
      //   );
      // document.getElementById("btn_download").click();
      this.setState({ toastRender: true, timer: null });
      const file = await api.get(
        `${process.env.REACT_APP_BASE_URL}/employees/${this.props.match.params.id}/${(isHistory ? 'history-attachments' : 'attachments')}/${attachId}/stream`
      );
      this.setState({ toastRender: false, timer:10 });
      if (file.data) {
        const linkSource = `data:${file.headers["content-type"]};base64,${
          file.data
        }`;
        const downloadLink = document.createElement("a");
        const fileName = (isHistory) ? e.target.name : data[0].originalName;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        this.setState({ toastRenderError: true });
      }
      this.setState({ toastRenderError: false });
    }
  };

  base64ToBlob(base64, type) {
    const binStr = atob( base64 );
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[ i ] = binStr.charCodeAt( i );
    }
    return new Blob( [ arr ], { type: type } );
  }

  viewFile = async (e, list) => {
    let data = list.filter(item => item.DocumentId == e.target.id);
    if (data.length) {
      this.setState({ toastView: true, timer: null });
      const file = await api.get(
        `${process.env.REACT_APP_BASE_URL}/employees/${this.props.match.params.id}/attachments/${data[0].id}/stream`
      );
      this.setState({ toastView: false, timer:10 });
      if (file.data) {
        let win = window.open();
        const newBlob = this.base64ToBlob(file.data, file.headers["content-type"]);

        win.document.write(
          `<iframe src="${ URL.createObjectURL(newBlob)}" style="width:100vw; height:100vh"></iframe>`
        );
      } else {
        this.setState({ toastRenderError: true });
      }
      this.setState({ toastRenderError: false });
    }
  };

  base64ToBlob(base64, type) {
    const binStr = atob( base64 );
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[ i ] = binStr.charCodeAt( i );
    }
    return new Blob( [ arr ], { type: type } );
  }

  // viewFile = async (e, list) => {
  //   let data = list.filter(item => item.DocumentId == e.target.id);

  //   if (data.length) {
  //     document
  //       .getElementById("btn_viewer")
  //       .setAttribute(
  //         "href",
  //         `${process.env.REACT_APP_BASE_URL}/employees/${this.props.match.params.id}/attachments/${data[0].id}/stream`
  //       );
  //     document.getElementById("btn_viewer").click();
  //   }

  //   if (file.data) {
  //     let win = window.open();
  //     const newBlob = this.base64ToBlob(file.data, file.headers["content-type"]);

  //     win.document.write(
  //       `<iframe src="${ URL.createObjectURL(newBlob)}" style="width:100vw; height:100vh"></iframe>`
  //     );
  //   } else {
  //     document.getElementById("close-modal-confirm").click();
  //     document.getElementById("closeModal").click();
  //     document.getElementById("modal-alert").click();
  //     this.setState({
  //       msgAlert: "Erro ao consultar documento, contate o suporte técnico!",
  //       classText: "text-warning"
  //     });
  //   }
  // };

  verifyDocumentsSuccess = () => {
    /**
     * employeeDocuments é os documentos CADASTRAIS já enviados do colaborador
     * employeeDocumentsPeriodic é os documentos MENSAIS já enviados do colaborador
     */
    const {
      employeeDocuments,
      employeeDocumentsPeriodic,
      typeAttach,
      documentsToUpload,
      documentsToUploadPeriodic
    } = this.state;

    let documentsToUploadIDS = documentsToUpload.map(
      item => item.id
    );

    let documentsToUploadPeriodicIDS = documentsToUploadPeriodic.map(
      item => item.id
    );

    console.log('ID DOCUMENTOS CADASTRAIS PARA SUBIR:', documentsToUploadIDS);

    let documentsSuccess = employeeDocuments.filter(
      item => (item.AttachmentStatusId == 2 || item.AttachmentStatusId == 4) && documentsToUploadIDS.indexOf(item.DocumentId) !== -1
    );
    console.log(
      "QUANTIDADE DE DOCUMENTOS APROVADOS DO TIPO 3 CADASTRAL: ",
      documentsSuccess.length
    );

    console.log(
      "QUANTIDADE DE DOCUMENTOS PARA UPDATE DO TIPO 3 CADASTRAL: ",
      documentsToUpload.length
    );
    console.log(documentsToUpload);

    let documentsSuccessPeriodic = employeeDocumentsPeriodic.filter(
      item => (item.AttachmentStatusId == 2 || item.AttachmentStatusId == 4) && documentsToUploadPeriodicIDS.indexOf(item.DocumentId) !== -1
    );
    
    console.log(
      "QUANTIDADE DE DOCUMENTOS APROVADOS DO TIPO 4 MENSAL: ",
      documentsSuccessPeriodic.length
    );

    if (typeAttach == "normal") {
      if (documentsSuccess.length == documentsToUpload.length) {
        return true;
      } else {
        return false;
      }
    } else {
      if (documentsSuccessPeriodic.length == documentsToUploadPeriodic.length) {
        return true;
      } else {
        return false;
      }
    }
  };

  // Verifica se possui documentos reprovados
  hasReprovedFile = () => {
    const {
      employeeDocuments: ed,
      employeeDocumentsPeriodic: ep,
      typeAttach: ta
    } = this.state;

    return ta === "normal"
      ? ed.some(doc => doc.AttachmentStatusId == 4)
      : ep.some(doc => doc.AttachmentStatusId == 4);
  };

  confirmStatusApprove = async (e, list) => {
    let attach = list.filter(item => item.DocumentId == e.target.id);
    let isPeriodic = e.target.name === "periodic";
    this.setState({
      msgError: null,
      idAttachment: attach[0].id,
      isPeriodic,
      typeAttach: e.target.name
    });
    document.getElementById("modal-confirm-document").click();
  };

  setStatusDocument = async () => {
    this.setState({ load: true });
    await api
      .patch(
        `/employees/${this.props.match.params.id}/attachments/${this.state.idAttachment}`,
        {
          AttachmentStatusId: 2,
          UserId: localStorage.getItem("userId")
        }
      )
      .then(async result => {
        console.log(
          "RESULTADO APÓS ATUALIZAÇÂO STATUS DO DOCUMENTO ------------------>",
          result
        );
        this.setState({ load: false, msgError: null });
        document.getElementById("close-modal-confirm-document").click();
        document.getElementById("modal-alert").click();
        this.setState({ msgAlert: result.data.msg, classText: "text-success" });
        await this.searchDocumentsEmployee();
        await this.searchDocumentsToEmployee();
        await this.setStatusEmployee();

        setTimeout(() => {
          this.closeAllModals();
          this.setState({ msgAlert: null, classText: null });
        }, 2000);


      })
      .catch(err => {
        if (
          err &&
          err.response.data.errors &&
          err.response.data.errors.length
        ) {
          this.setState({
            msgError: err.response.data.errors[0].msg,
            classText: "text-danger"
          });
        } else {
          this.setState({
            msgError: "Erro no envio. Tente novamente!",
            classText: "text-info"
          });
        }
      });
  };

  confirmStatusReject = async (e, list) => {
    let attach = list.filter(item => item.DocumentId == e.target.id);
    this.setState({
      msgError: null,
      idAttachment: attach[0].id,
      typeAttach: e.target.name
    });
    document.getElementById("motivo").value = "";
    document.getElementById("modal-reject").click();
  };

  setStatusEmployee = async () => {
    if (this.verifyDocumentsSuccess()) {
      const hasreproved = this.hasReprovedFile();
      const { isPeriodic } = this.state;
      const isAproved = isPeriodic ? 5 : 4;
      await api
        .patch(`/employees/${this.props.match.params.id}`, {
          EmployeeStatusId: hasreproved ? 3 : isAproved
        })
        .then(async result => {
          console.log(
            "RESULTADO DA ATUALIZAÇÃO DO STATUS DO EMPLOYEE ------------------",
            result
          );
          await this.searchDataEmployee();
          this.setState({
            msgAlert: result.data.msg,
            classText: "text-success",
            load: false,
            msgError: null
          });

          setTimeout(() => {
            this.setState({ msgAlert: null, classText: null });
          }, 2000);

        })
        .catch(err => {
          this.setState({
            msgError: "Erro na atualização do status da empresa",
            classText: "text-info"
          });
        });
    } else {
      console.log(
        "NÃO FOI ENVIADO TODOS OS DOCUMENTOS AINDA PARA ALTERAR O STATUS"
      );
    }
  };

  setStatusRejectDocument = async () => {
    this.setState({ load: true, msgError: null, msgAlert: null });

    let motivo = document.getElementById("motivo").value;
    await api
      .patch(
        `/employees/${this.props.match.params.id}/attachments/${this.state.idAttachment}`,
        {
          AttachmentStatusId: 4,
          note: motivo,
          UserId: localStorage.getItem("userId")
        }
      )
      .then(async result => {
        document.getElementById("close-modal-reject").click();
        document.getElementById("modal-alert").click();
        this.setState({
          load: false,
          msgError: null,
          msgAlert: result.data.msg,
          classText: "text-success"
        });
        await this.searchDocumentsEmployee();
        await this.searchDocumentsToEmployee();
        await this.setStatusEmployee();

        setTimeout(() => {
          this.closeAllModals();
          this.setState({ msgAlert: null, classText: null });
        }, 2000);
      })
      .catch(err => {
        if (err && err.response.data.errors[0]) {
          this.setState({
            msgError: err.response.data.errors[0].msg,
            classText: "text-danger"
          });
        } else {
          this.setState({
            msgError: "Erro no envio. Tente novamente!",
            classText: "text-danger"
          });
        }
      });
  };

  setStatusRepostDocument = async () => {
    
    this.setState({ load: true });
    await api
      .delete(
        `/employees/${this.props.match.params.id}/deleteattach/${this.state.idAttachment}/${this.state.repostType}`
      )
      .then(async result => {
        console.log(
          "RESULTADO APÓS ATUALIZAÇÂO STATUS DO DOCUMENTO ------------------>",
          result
        );
        this.setState({ msgAlert: result.data.msg, classText: "text-success" });
        await this.searchDocumentsEmployee();
        await this.searchDocumentsToEmployee();
        await this.setStatusEmployee();

        setTimeout(() => {
          this.closeAllModals();
          this.setState({ msgAlert: null, classText: null });
        }, 2000);
      })
      .catch(err => {
        if (err && err.response.data.errors[0]) {
          this.setState({
            msgError: err.response.data.errors[0].msg,
            classText: "text-danger"
          });
        } else {
          this.setState({
            msgError: "Erro no envio. Tente novamente!",
            classText: "text-danger"
          });
        }
      });
  };

  toggleDocs = e => {
    const { showDocs } = this.state;
    this.setState({ showDocs: !showDocs });
  };

  toggleDocsPeriodic = e => {
    const { showDocsPeriodic } = this.state;
    this.setState({ showDocsPeriodic: !showDocsPeriodic });
  };

  handleChangeDate = async e => {
    const { name, value } = e.target;

    this.setState({ [name]: value }, async () => {
      const { year, month } = this.state;
      await api
        .get(
          `/employees/${this.props.match.params.id}/attachments?DocumentTypeId=4&year=${year}&month=${month}`
        )
        .then(response => {
          this.setState((state, props) => ({
            ...state,
            employeeDocumentsPeriodic: response.data.rows || {}
          }));
          this.forceUpdate();
        });
    });
  };

  handleOpenModal = () => {
    this.setState({ openModal: !this.state.openModal });
  };

  closeAllModals = () => {

    // get modals
    const modals = document.getElementsByClassName('modal');
    document.querySelector('body').classList.remove('modal-open');

    // on every modal change state like in hidden modal
    for(let i=0; i<modals.length; i++) {
      modals[i].classList.remove('show');
      modals[i].setAttribute('aria-hidden', 'true');
      modals[i].setAttribute('style', 'display: none');
    }

     // get modal backdrops
     const modalsBackdrops = document.getElementsByClassName('modal-backdrop');

     // remove every modal backdrop
     for(let i=0; i<modalsBackdrops.length; i++) {
       document.body.removeChild(modalsBackdrops[i]);
     }
  };

  throwbackHistory = () => {
    window.history.back(-1)
  }

  fetchHistoricalDocuments = async (documentId, list) => {
    let attach = list.filter(item => item.DocumentId == documentId);
    
    try {
      const response = await api.get(
        `/employees/${this.props.match.params.id}/attachments/history?DocumentId=${documentId}`
      );
      this.setState({ historicalDocuments: response.data.rows, showHistoricalDocs: true });
    } catch (error) {
      console.error("Error fetching historical documents:", error);
    }
  };

  closeHistoricalDocs = () => {
    this.setState({ showHistoricalDocs: false, historicalDocuments: [] });
  };

  fetchLostFiles = async () => {
    try {
      const response = await api.get(
        `/employees/${this.props.match.params.id}/lost-files`
      );
      this.setState({ lostFiles: response.data.rows, showLostFiles: true });
    } catch (error) {
      console.error("Error fetching lost files:", error);
    }
  };

  closeLostFiles = () => {
    this.setState({ showLostFiles: false, lostFiles: [] });
  };

  downloadLostFile = async (fileName) => {
    try {
      this.setState({ toastRender: true, timer: null });
      
      const encodedFileName = encodeURIComponent(fileName);
      const downloadLink = document.createElement("a");
      downloadLink.href = `${process.env.REACT_APP_BASE_URL}/employees/${this.props.match.params.id}/lost-files/${encodedFileName}/download`;
      downloadLink.download = fileName;
      downloadLink.click();
      
      this.setState({ toastRender: false, timer: 10 });
    } catch (error) {
      console.error("Error downloading lost file:", error);
      this.setState({ toastRenderError: true, toastRender: false });
    }
  };

  toggleCategory = (category) => {
    this.setState(prevState => ({
      expandedCategories: {
        ...prevState.expandedCategories,
        [category]: !prevState.expandedCategories[category]
      }
    }));
  };

  // Bulk approval methods
  toggleBulkApprovalMode = () => {
    const { bulkApprovalMode } = this.state;
    
    if (!bulkApprovalMode) {
      // Entering bulk approval mode
      this.setState({
        bulkApprovalMode: true,
        selectedDocuments: [],
        showBulkApproveButton: false
      });
    } else {
      // Exiting bulk approval mode
      this.setState({
        bulkApprovalMode: false,
        selectedDocuments: [],
        showBulkApproveButton: false
      });
    }
  };

  // Handle individual document selection
  toggleDocumentSelection = (documentId) => {
    const { selectedDocuments } = this.state;
    let newSelectedDocuments;
    
    if (selectedDocuments.includes(documentId)) {
      // Remove from selection
      newSelectedDocuments = selectedDocuments.filter(id => id !== documentId);
    } else {
      // Add to selection
      newSelectedDocuments = [...selectedDocuments, documentId];
    }
    
    this.setState({
      selectedDocuments: newSelectedDocuments,
      showBulkApproveButton: newSelectedDocuments.length > 0
    });
  };

  // Select all approvable documents
  selectAllApprovableDocuments = () => {
    const approvableDocuments = this.getBulkApprovableDocuments();
    const documentIds = approvableDocuments.map(doc => doc.id);
    
    this.setState({
      selectedDocuments: documentIds,
      showBulkApproveButton: documentIds.length > 0
    });
  };

  // Clear all selections
  clearDocumentSelection = () => {
    this.setState({
      selectedDocuments: [],
      showBulkApproveButton: false
    });
  };

  getBulkApprovableDocuments = () => {
    const { employeeDocumentsPeriodic, documentsToUploadPeriodic } = this.state;
    
    return documentsToUploadPeriodic.filter(docTemplate => {
      // Only include documents that are uploaded but not yet approved
      const uploadedDoc = employeeDocumentsPeriodic.find(doc => doc.DocumentId === docTemplate.id);
      return uploadedDoc && uploadedDoc.AttachmentStatusId !== 2; // Not approved yet
    });
  };

  canDocumentBeSelected = (id, list) => {
    // Check if document is uploaded but not yet approved
    const uploadedDoc = list.find(doc => doc.DocumentId === id);
    return uploadedDoc && uploadedDoc.AttachmentStatusId !== 2; // Not approved yet
  };

  isSamplingApprovalNote = (note) => {
    return note && note.includes('Aprovado por amostragem (usuário:');
  };

  confirmBulkApproval = async () => {
    try {
      this.setState({ load: true });
      
      const { selectedDocuments, year, month } = this.state;
      const userName = localStorage.getItem('name');
      const employeeId = this.props.match.params.id;
      
      if (selectedDocuments.length === 0) {
        this.setState({
          msgAlert: 'Por favor, selecione pelo menos um documento',
          classText: 'text-danger',
          load: false
        });
        return;
      }
      
      const response = await api.patch(`/employees/${employeeId}/bulk-approve-monthly`, {
        documentIds: selectedDocuments,
        year,
        month,
        note: `Aprovado por amostragem (usuário: ${userName})`
      });
      
      this.setState({
        msgAlert: response.data.msg,
        classText: 'text-success',
        load: false,
        bulkApprovalMode: false,
        selectedDocuments: [],
        showBulkApproveButton: false,
        typeAttach: 'periodic',
        isPeriodic: true
      });

      // Refresh the documents to show the updates
      await this.searchDocumentsEmployee();
      await this.searchDocumentsToEmployee();
      await this.setStatusEmployee();

    } catch (err) {
      this.setState({
        msgAlert: 'Erro ao aprovar documentos por amostragem',
        classText: 'text-danger',
        load: false
      });
    }
  };

  getDocumentCategory = (document) => {
    const { employeeDocumentCategories } = this.state;
    
    // First try exact matching
    for (const [category, docNames] of Object.entries(employeeDocumentCategories)) {
      // Check if document description exactly matches any name in this category
      const exactMatch = docNames.some(docName => 
        document.description.trim() === docName.trim()
      );
      
      if (exactMatch) {
        return category;
      }
    }
    
    // If no exact match found, try case-insensitive matching
    for (const [category, docNames] of Object.entries(employeeDocumentCategories)) {
      // Check if document description matches any name in this category (case-insensitive)
      const caseInsensitiveMatch = docNames.some(docName => 
        document.description.trim().toUpperCase() === docName.trim().toUpperCase()
      );
      
      if (caseInsensitiveMatch) {
        return category;
      }
    }
    
    // If no match found at all, return null (will be added to "Outros")
    return null;
  };

  groupDocumentsByCategory = (documents) => {
    const grouped = {
      categorized: {},
      uncategorized: []
    };

    documents.forEach(doc => {
      const category = this.getDocumentCategory(doc);
      if (category) {
        if (!grouped.categorized[category]) {
          grouped.categorized[category] = [];
        }
        grouped.categorized[category].push(doc);
      } else {
        grouped.uncategorized.push(doc);
      }
    });

    // Add uncategorized documents to "Outros" category if there are any
    if (grouped.uncategorized.length > 0) {
      grouped.categorized['Outros pertinentes à função'] = grouped.uncategorized;
      grouped.uncategorized = []; // Clear uncategorized array since we moved them to Outros
    }

    return grouped;
  };

  renderDocumentRow = (item, documents, isPeriodic = false) => {
    if (this.verifyFileApproval(item.id)) {
      return (
        <div className="row detail-company detail-company-employee" key={item.id}>
          <div className="col-md-3 p-t-10">
            <label>{item.description}</label>
            {this.verifyStatus(item.id, documents) ? (
              <i className="label label-light-primary m-l-20" id={item.id}>
                {this.verifyStatus(item.id, documents)}
              </i>
            ) : null}
            {this.verifyStatusNote(item.id, documents) ? (
              <i className="label label-light-danger m-l-20" id={item.id}>
                {this.verifyStatusNote(item.id, documents)}
              </i>
            ) : null}
            {this.verifyStatusExpired(item.id, documents) ? (
              <i className="label label-light-danger m-l-20" id={item.id}>
                {this.verifyStatusExpired(item.id, documents)}
              </i>
            ) : null}
          </div>
          <div className="col-md-3 p-10">
            {this.verifyFile(item.id, documents) &&
            !this.verifyDocumentNotApplicable(item.id, documents) ? (
              <>
                <button
                  className="btn btn-sm btn-rounded btn-outline-success"
                  id={item.id}
                  onClick={e => this.downloadFile(e, documents)}
                >
                  <i className="fa fa-download" id={item.id} />
                </button>
                <button
                  className="btn btn-sm btn-rounded btn-outline-success"
                  title="Visualizar Documento"
                  id={item.id}
                  onClick={e => this.viewFile(e, documents)}
                >
                  <i className="fa fa-search" id={item.id} />
                </button>
              </>
            ) : null}
            {this.verifyDocumentNotApplicable(item.id, documents) ? (
              <i className="label label-light-warning" id={item.id}>
                Documento não Aplicável
              </i>
            ) : null}
          </div>
          <div className="col-md-3 p-10">
            {!this.verifyStatus(item.id, documents) && this.state.employeeStatusId != 1 ? (
              <>
                <button
                  className="btn btn-rounded btn-danger"
                  disabled={!this.verifyFile(item.id, documents)}
                  id={item.id}
                  name={isPeriodic ? "periodic" : "normal"}
                  onClick={e => this.confirmStatusReject(e, documents)}
                >
                  Rejeitar
                </button>
                <button
                  className="btn btn-rounded btn-success"
                  disabled={!this.verifyFile(item.id, documents)}
                  id={item.id}
                  name={isPeriodic ? "periodic" : "normal"}
                  onClick={e => this.confirmStatusApprove(e, documents)}
                >
                  Aprovar
                </button>
              </>
            ) : null}
            {this.verifyFile(item.id, documents) && this.state.user_sector == '3' ? (
              <button
                className="btn btn-sm btn-rounded btn-outline-success"
                id={item.id}
                name="normal"
                onClick={e => this.confirmRepostFile(e, documents, isPeriodic ? 'employeePeriodic' : 'employee')}
              >
                <i className="fa fa-repeat" id={item.id} />
                &nbsp;&nbsp;Repostar
              </button>
            ) : null}
            <button
              className="btn btn-sm btn-rounded btn-outline-info"
              onClick={() => this.fetchHistoricalDocuments(item.id, documents)}
            >
              Histórico
            </button>
          </div>
          <div className="col-md-3 p-10">
            <br />
            <b>Data Validade:</b> {this.showValidityDate(item, documents)}
          </div>
        </div>
      );
    }
    return null;
  };

  renderDocumentSection = (documents, isPeriodic = false) => {
    const { expandedCategories } = this.state;
    const grouped = this.groupDocumentsByCategory(documents);

    // Define the order of categories
    const categoryOrder = [
      'Dados do Colaborador',
      'Saúde Ocupacional',
      'Certificados de Capacitação',
      'Outros pertinentes à função'
    ];

    // Sort categories according to the defined order
    const sortedCategories = Object.entries(grouped.categorized).sort((a, b) => {
      const indexA = categoryOrder.indexOf(a[0]);
      const indexB = categoryOrder.indexOf(b[0]);
      return indexA - indexB;
    });

    return (
      <>
        {/* Render all categorized documents in the specified order */}
        {sortedCategories.map(([category, docs]) => (
          <div key={category} className="document-category mb-3">
            <div 
              className="category-header p-2 bg-light d-flex justify-content-between align-items-center" 
              style={{ cursor: 'pointer' }}
              onClick={() => this.toggleCategory(category)}
            >
              <h5 className="mb-0">{category}</h5>
              <i className={`fa fa-chevron-${expandedCategories[category] ? 'up' : 'down'}`} />
            </div>
            {expandedCategories[category] && (
              <div className="category-content">
                {docs.map(doc => this.renderDocumentRow(doc, isPeriodic ? this.state.employeeDocumentsPeriodic : this.state.employeeDocuments, isPeriodic))}
              </div>
            )}
          </div>
        ))}
      </>
    );
  };

  renderPeriodicDocumentSection = (documents) => {
    const { showDocsPeriodic, employeeDocumentsPeriodic, employeeStatusId, bulkApprovalMode, selectedDocuments } = this.state;
    
    return (
      <>
        {documents.map(item => {
          if (this.verifyFileApprovalPeriodic(item.id)) {
            return (
              <div
                className={showDocsPeriodic ? "row detail-company detail-company-employee" : "hide"}
                key={item.id}
                style={bulkApprovalMode && selectedDocuments.includes(item.id) ? 
                  { backgroundColor: '#fff3cd', border: '1px solid #ffeaa7', borderRadius: '5px', padding: '10px', margin: '5px 0' } : 
                  {}
                }
              >
                <div className="col-md-3 p-t-10">
                  <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                    {bulkApprovalMode && this.canDocumentBeSelected(item.id, employeeDocumentsPeriodic) && (
                      <div style={{ marginRight: '12px', marginBottom: '5px' }}>
                        <input
                          type="checkbox"
                          id={`checkbox-${item.id}`}
                          checked={selectedDocuments.includes(item.id)}
                          onChange={(e) => {
                            e.stopPropagation();
                            this.toggleDocumentSelection(item.id);
                          }}
                          style={{ 
                            width: '18px', 
                            height: '18px',
                            cursor: 'pointer',
                            accentColor: '#ffc107'
                          }}
                        />
                        <label 
                          htmlFor={`checkbox-${item.id}`}
                          style={{ 
                            marginLeft: '6px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            color: '#ffc107',
                            fontWeight: 'bold'
                          }}
                        >
                          Selecionar
                        </label>
                      </div>
                    )}
                    <label className="m-b-0" style={{ flex: 1 }}>{item.description}</label>
                  </div>
                  {this.verifyStatus(item.id, employeeDocumentsPeriodic) ? (
                    <i className="label label-light-primary m-l-20" id={item.id}>
                      {this.verifyStatus(item.id, employeeDocumentsPeriodic)}
                    </i>
                  ) : null}
                  {this.verifyStatusNote(item.id, employeeDocumentsPeriodic) ? (
                    <i className={this.isSamplingApprovalNote(this.verifyStatusNote(item.id, employeeDocumentsPeriodic)) ? 
                      "text-warning label label-light-warning m-l-20" : 
                      "text-danger label label-light-danger m-l-20"}>
                      {this.verifyStatusNote(item.id, employeeDocumentsPeriodic)}
                    </i>
                  ) : null}
                  {this.verifyStatusExpired(item.id, employeeDocumentsPeriodic) ? (
                    <i className="label label-light-danger m-l-20" id={item.id}>
                      {this.verifyStatusExpired(item.id, employeeDocumentsPeriodic)}
                    </i>
                  ) : null}
                </div>
                <div className="col-md-3 p-10">
                  {this.verifyFile(item.id, employeeDocumentsPeriodic) &&
                  !this.verifyDocumentNotApplicable(item.id, employeeDocumentsPeriodic) ? (
                    <>
                      <button
                        className="btn btn-sm btn-rounded btn-outline-success"
                        title="Download"
                        id={item.id}
                        onClick={e => this.downloadFile(e, employeeDocumentsPeriodic)}
                      >
                        <i className="fa fa-download" id={item.id} />
                      </button>
                      <button
                        className="btn btn-sm btn-rounded btn-outline-success"
                        title="Visualizar Documento"
                        id={item.id}
                        onClick={e => this.viewFile(e, employeeDocumentsPeriodic)}
                      >
                        <i className="fa fa-search" id={item.id} />
                      </button>
                    </>
                  ) : null}
                  {this.verifyDocumentNotApplicable(item.id, employeeDocumentsPeriodic) ? (
                    <i className="label label-light-warning" id={item.id}>
                      Documento não Aplicável
                    </i>
                  ) : null}
                </div>
                <div className="col-md-3 p-10">
                  {!this.verifyStatus(item.id, employeeDocumentsPeriodic) && 
                  employeeStatusId != 1 && 
                  this.verifyFileApprovalPeriodicSector(item.id) ? (
                    <>
                      <button
                        className="btn btn-rounded btn-danger"
                        disabled={!this.verifyFile(item.id, employeeDocumentsPeriodic)}
                        id={item.id}
                        onClick={e => this.confirmStatusReject(e, employeeDocumentsPeriodic)}
                      >
                        Rejeitar
                      </button>
                      <button
                        className="btn btn-rounded btn-success"
                        disabled={!this.verifyFile(item.id, employeeDocumentsPeriodic)}
                        id={item.id}
                        name="periodic"
                        onClick={e => this.confirmStatusApprove(e, employeeDocumentsPeriodic)}
                      >
                        Aprovar
                      </button>
                    </>
                  ) : null}
                  
                  {this.verifyFile(item.id, employeeDocumentsPeriodic) &&
                  this.state.user_sector == '3' ? (
                    <button
                      className="btn btn-sm btn-rounded btn-outline-success"
                      id={item.id}
                      name="normal"
                      onClick={e => this.confirmRepostFile(e, employeeDocumentsPeriodic, 'employeePeriodic')}
                    >
                      <i className="fa fa-repeat" id={item.id} />
                      &nbsp;&nbsp;Repostar
                    </button>
                  ) : null}
                 

                </div>
                <div className="col-md-3">
                  {this.verifyDocumentMonth(item.id, employeeDocumentsPeriodic)}{" "}
                  -{" "}
                  {this.verifyDocumentYear(item.id, employeeDocumentsPeriodic)}{" "}
                  <br />
                  <b>Data Validade:</b>{" "}
                  {this.showValidityDate(item, employeeDocumentsPeriodic)}
                </div>
              </div>
            );
          }
          return null;
        })}
      </>
    );
  };

  render() {
    const {
      employeeDocuments,
      employeeDocumentsPeriodic,
      load,
      dataEmployee,
      EmployeeStatus,
      showDocs,
      employeeStatusId,
      documentsToUpload,
      documentsToUploadPeriodic,
      showDocsPeriodic,
      year,
      month,
      msgAlert,
      msgError,
      erroDelete,
      classText,
      titleDocumentValidate,
      updateDate,
      isValidadeCalendar,
      functions,
      sectors,
      openModal,
      toastRender,
      toastRenderError,
      toastView,
      timer,
      historicalDocuments,
      showHistoricalDocs,
      lostFiles,
      showLostFiles,
      bulkApprovalMode,
      selectedDocuments,
      showBulkApproveButton
    } = this.state;
    return (
      <Fragment>
        {timer ? (
          <Toast timer={timer} />
        ) : null }
        {
          toastRender ? (
            <Toast message="Iniciando download, aguarde..." type="info" timer={timer} />
          ) : null
        }
        {
          toastRenderError ? (
            <Toast message="Erro ao consultar documento, contate o suporte técnico!" type="error"/>
          ) : null
        }
        {
          toastView ? (
            <Toast message="Preparando para visualizar o arquivo, aguarde..." type="info" timer={timer} />
          ) : null
        }
        <a href="#" id="btn_download" target="_blank" download />
        <a href="#" id="btn_viewer" target="_blank" />

        <div className="row page-titles">
          <div className="col-md-5 col-8 align-self-center">
            <h3 className="text-themecolor">
              Documentos de Funcionário
              {load ? <i className="fa fa-spin fa-spinner" /> : null}
            </h3>
          </div>
        </div>

        <div className="row">
          <div className="m-b-10">
            <a
              className="btn btn-rounded btn-outline-primary"
              onClick={this.throwbackHistory}
            >
              <i className="mdi mdi-arrow-left" />
            </a>
          </div>
          <div className="col-md-12 alert alert-primary">
            <span>
              Status do funcionário {dataEmployee.name}:
              <strong> {EmployeeStatus}</strong>
            </span>
          </div>
        </div>

        <form action="javascript:void(0)" id="formDocuments">
          {/* Inicio Formulário dados do colaborador */}
          <div className="row m-b-15">
            <div className="col-md-12">
              <fieldset>
                <div className="row detail-company">
                  <div className="col-md-6 p-10">
                    <strong className="text-primary p-10">Nome:</strong>
                    <span>{dataEmployee.name}</span>
                  </div>
                  <div className="col-md-6 p-10">
                    <strong className="text-primary p-10">Email:</strong>
                    <span>{dataEmployee.email}</span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">Data Nasc.:</strong>
                    <span>
                      <Moment format="DD/MM/YYYY">
                        {dataEmployee.birthDate}
                      </Moment>
                    </span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">Setor:</strong>

                    {dataEmployee.Sector ? (
                      <span>{dataEmployee.Sector.name}</span>
                    ) : null}
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">Função:</strong>
                    <span>
                      {dataEmployee.Function
                        ? dataEmployee.Function.description
                        : null}
                    </span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">Telefone:</strong>
                    <span>{dataEmployee.phone}</span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">CPF:</strong>
                    <span>{dataEmployee.cpf}</span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">RG:</strong>
                    <span>{dataEmployee.rg}</span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">Estado:</strong>
                    <span>{dataEmployee.state}</span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">Cidade:</strong>
                    <span>{dataEmployee.city}</span>
                  </div>
                  <div className="col-md-4 p-10">
                    <strong className="text-primary p-10">Bairro:</strong>
                    <span>{dataEmployee.district}</span>
                  </div>
                  <div className="col-md-12 p-10">
                    <strong className="text-primary p-10">Endereço:</strong>
                    <span>{dataEmployee.address}</span>
                  </div>
                  <div className="col-md-3 p-10">
                    <strong className="text-primary p-10">Número:</strong>
                    <span>{dataEmployee.number}</span>
                  </div>
                  <div className="col-md-6 p-10">
                    <strong className="text-primary p-10">Complemento:</strong>
                    <span>{dataEmployee.complement}</span>
                  </div>
                  <div className="col-md-3 p-10">
                    <strong className="text-primary p-10">Editar:</strong>
                    <button
                      className="btn btn-rounded btn-outline-info"
                      onClick={() =>
                        this.setState({
                          openModal: !openModal
                        })
                      }
                    >
                      <i className="fa fa-edit" />
                    </button>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          {/* Fim Formulário dados do colaborador */}

          <EmployeeForm
            functions={functions}
            sectors={sectors}
            open={openModal}
            employeeData={dataEmployee}
            updateEmployee={this.updateEmployee}
            handleOpenModal={() => this.handleOpenModal}
          />

          {/* Inicio documentos cadastrais do colaborador */}
          <div className="row card">
            <div className="col-md-12">
              <div className="card-body">
                <h4 className="card-title">
                  Documentos &nbsp;
                  <button
                    className="btn btn-sm btn-rounded btn-outline-success"
                    title="Omitir lista de documentos"
                    onClick={this.toggleDocs}
                  >
                    <i className={showDocs ? "fa fa-eye" : "fa fa-eye-slash"} />
                  </button>
                  &nbsp;
                  <button
                    className="btn btn-sm btn-rounded btn-outline-warning"
                    title="Ver arquivos não catalogados"
                    onClick={this.fetchLostFiles}
                  >
                    <i className="fa fa-exclamation-triangle" /> Arquivos Não Catalogados
                  </button>
                </h4>

                {showDocs && documentsToUpload.length ? 
                  this.renderDocumentSection(documentsToUpload) 
                  : null
                }
              </div>
            </div>
          </div>
          {/* Fim documentos cadastrais do colaborador */}

          {/* Inicio documentos mensais do colaborador */}
          <div className="row card">
            <div className="col-md-12">
              <div className="card-body">
                <h4 className="card-title">
                  Documentos Mensais &nbsp;
                  <button
                    className="btn btn-sm btn-rounded btn-outline-success"
                    title="Omitir lista de documentos"
                    onClick={this.toggleDocsPeriodic}
                  >
                    <i
                      className={
                        showDocsPeriodic ? "fa fa-eye" : "fa fa-eye-slash"
                      }
                    />
                  </button>
                  &nbsp;
                  <button
                    className={`btn btn-sm btn-rounded ${bulkApprovalMode ? 'btn-warning' : 'btn-outline-warning'}`}
                    title="Ativar aprovação por amostragem"
                    onClick={this.toggleBulkApprovalMode}
                  >
                    <i className={bulkApprovalMode ? "fa fa-check-square" : "fa fa-square-o"} />
                    &nbsp;Aprovação por Amostragem
                  </button>
                </h4>
                {/* Inicio dropdown de datas */}
                <DropMonthYear
                  year={year}
                  month={month}
                  handleChangeDate={this.handleChangeDate}
                />
                {/* Fim dropdown de datas */}
                
                {/* Bulk Approval Controls */}
                {bulkApprovalMode && (
                  <div className="row" style={{ marginBottom: '15px' }}>
                    <div className="col-md-12">
                      <div className="alert alert-warning">
                        <div className="row">
                          <div className="col-md-6">
                            <strong>Modo Aprovação por Amostragem Ativo</strong>
                            <br />
                            <small>{selectedDocuments.length} documento(s) selecionado(s) para {month}/{year}</small>
                          </div>
                          <div className="col-md-6 text-right">
                            <button
                              className="btn btn-outline-warning btn-xs m-r-5"
                              onClick={this.selectAllApprovableDocuments}
                            >
                              <i className="fa fa-check-square" />
                              &nbsp;Selecionar Todos
                            </button>
                            <button
                              className="btn btn-outline-secondary btn-xs"
                              onClick={this.clearDocumentSelection}
                            >
                              <i className="fa fa-square-o" />
                              &nbsp;Limpar Seleção
                            </button>
                          </div>
                        </div>
                        
                        {showBulkApproveButton && (
                          <div className="m-t-10">
                            <button
                              className="btn btn-warning btn-sm"
                              onClick={this.confirmBulkApproval}
                              disabled={load}
                            >
                              {load ? <i className="fa fa-spin fa-spinner" /> : <i className="fa fa-check" />}
                              &nbsp;Aprovar Documentos Selecionados (Amostragem)
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {showDocsPeriodic && documentsToUploadPeriodic.length ? 
                  this.renderPeriodicDocumentSection(documentsToUploadPeriodic)
                  : null
                }
              </div>
            </div>
          </div>
        </form>
        {/* Fim documentos cadastrais do colaborador */}

        <ModalConfirm
          title="Confirmação"
          msg="Tem certeza que deseja enviar os documentos do colaborador para aprovação?"
          function={this.alterStatusEmployee}
          msgError={erroDelete}
        />
        <ModalAlert
          title="Envio de Documento(s)"
          msg={msgAlert}
          function=""
          classText={classText}
        />

        <div
          id="modal-confirm-document"
          data-toggle="modal"
          data-target=".modal-confirm-document"
        />

        <div
          id="modal-repost"
          data-toggle="modal"
          data-target=".modal-repost"
        />

        <div
          className="modal fade modal-repost"
          data-backdrop="static"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myLargeModalLabel">
                  Repostar documento
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>
                        Tem certeza que deseja solictar a repostagem do documento?
                        <br />
                      </label>
                    </div>
                  </div>

                  {msgAlert ? (
                    <div className="col-md-12 p-t-20">
                      <div className="alert alert-success">{msgAlert}</div>
                    </div>
                  ) : null}

                  {msgError ? (
                    <div className="col-md-12 p-t-20">
                      <div className="alert alert-danger">{msgError}</div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="modal-footer">

                  <button
                    className="col-md-2 btn waves-effect waves-light btn-rounded btn-success"
                    onClick={this.setStatusRepostDocument}
                  >
                    Confirmar
                  </button>

                <button
                  id="close-modal-repost"
                  type="button"
                  className="col-md-2 btn btn-secondary btn-rounded waves-effect"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Fim Modal Repost documento empresa */}


        <div
          className="modal fade modal-confirm-document"
          data-backdrop="static"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myLargeModalLabel">
                  Aprovar
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    Tem certeza que deseja aprovar o documento?
                  </div>

                  {this.props.msgError ? (
                    <div className="col-md-12 p-t-20">
                      <div className="alert alert-danger">
                        {this.props.msgError}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="col-md-2 btn waves-effect waves-light btn-rounded btn-success"
                  onClick={this.setStatusDocument}
                >
                  Confirmar
                </button>
                <button
                  id="close-modal-confirm-document"
                  type="button"
                  className="col-md-2 btn btn-secondary btn-rounded waves-effect"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          id="modal-reject"
          data-toggle="modal"
          data-target=".modal-reject"
        />

        <div
          id="modal-validade-date"
          data-toggle="modal"
          data-target=".modal-validade-date"
        ></div>

        <div
          className="modal fade modal-reject"
          data-backdrop="static"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myLargeModalLabel">
                  Rejeitar
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>
                        Tem certeza que deseja rejeitar o documento?
                        <br />
                        Coloque o motivo no campo abaixo.
                      </label>
                      <textarea id="motivo" className="form-control" rows="5" />
                    </div>
                  </div>

                  {msgAlert ? (
                    <div className="col-md-12 p-t-20">
                      <div className="alert alert-success">{msgAlert}</div>
                    </div>
                  ) : null}

                  {msgError ? (
                    <div className="col-md-12 p-t-20">
                      <div className="alert alert-danger">{msgError}</div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="col-md-2 btn waves-effect waves-light btn-rounded btn-success"
                  onClick={this.setStatusRejectDocument}
                >
                  Confirmar
                </button>
                <button
                  id="close-modal-reject"
                  type="button"
                  className="col-md-2 btn btn-secondary btn-rounded waves-effect"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade modal-validade-date"
          data-backdrop="static"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-sm">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myLargeModalLabel">
                  {titleDocumentValidate}
                  {load ? <i className="fa fa-spin fa-spinner"></i> : null}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body row">
                <div className="col-md-12 p-3">
                  {updateDate ? (
                    <div className="alert alert-success">
                      Atualizado com sucesso!
                    </div>
                  ) : null}

                  <div className="col-md-12">
                    <span>
                      Nova validade <i className="text-danger">*</i>
                    </span>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        id="data_integracao"
                        onChange={this.ValidadeCalendar}
                      />
                      <span className="input-group-addon">
                        <i className="icon-calender"></i>
                      </span>
                    </div>
                  </div>
                </div>

                {msgError ? (
                  <div className="col-md-12 p-t-20 text-sm">
                    <div className="alert alert-danger">{msgError}</div>
                  </div>
                ) : null}
              </div>
              <div className="modal-footer">
                {!updateDate ? (
                  <button
                    onClick={this.updateDateDocument}
                    disabled={!isValidadeCalendar}
                    className="col-md-6 btn waves-effect waves-light btn-rounded btn-success"
                  >
                    Salvar
                  </button>
                ) : null}
                <button
                  type="button"
                  id="closeModal"
                  className="col-md-6 btn btn-secondary btn-rounded waves-effect"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>

        {showHistoricalDocs && (
          <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show" style={{ display: "block", background: "rgba(0, 0, 0, 0.5)" }}>
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Histórico de Documentos</h5>
                    <button
                      type="button"
                      className="close"
                      onClick={this.closeHistoricalDocs}
                    >
                      ×
                    </button>
                  </div>
                  <div className="modal-body">
                    {historicalDocuments.length ? (
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th>Nome do Documento</th>
                              <th>Data</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {historicalDocuments.map((doc) => (
                              <tr key={doc.id}>
                                <td>{doc.originalName}</td>
                                <td>
                                  <Moment format="DD/MM/YYYY HH:mm">{doc.createdAt}</Moment>
                                </td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-rounded btn-outline-success"
                                    onClick={() => this.downloadFile({ target: { id: doc.DocumentId, attachId:doc.id, name: doc.originalName } }, historicalDocuments, true)}
                                  >
                                    <i className="fa fa-download" /> Download
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <p className="text-center text-muted">Nenhum documento histórico encontrado.</p>
                    )}
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={this.closeHistoricalDocs}
                    >
                      Fechar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {showLostFiles && (
          <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show" style={{ display: "block", background: "rgba(0, 0, 0, 0.5)" }}>
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      <i className="fa fa-exclamation-triangle text-warning" /> Arquivos Não Catalogados
                    </h5>
                    <button
                      type="button"
                      className="close"
                      onClick={this.closeLostFiles}
                    >
                      ×
                    </button>
                  </div>
                  <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                    {lostFiles.length ? (
                      <>
                        <div className="alert alert-warning">
                          <strong>{lostFiles.length}</strong> arquivo(s) encontrado(s) no sistema de arquivos que não estão catalogados no banco de dados.
                        </div>
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th>Nome do Arquivo</th>
                                <th>Tamanho</th>
                                <th>Data de Criação</th>
                                <th>Ações</th>
                              </tr>
                            </thead>
                            <tbody>
                              {lostFiles.map((file, index) => (
                                <tr key={index}>
                                  <td>{file.fileName}</td>
                                  <td>{(file.size / 1024).toFixed(2)} KB</td>
                                  <td>
                                    <Moment format="DD/MM/YYYY HH:mm">{file.createdAt}</Moment>
                                  </td>
                                  <td>
                                    <button
                                      className="btn btn-sm btn-rounded btn-outline-primary"
                                      onClick={() => this.downloadLostFile(file.fileName)}
                                    >
                                      <i className="fa fa-download" /> Download
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </>
                    ) : (
                      <p className="text-center text-muted">Nenhum arquivo não catalogado encontrado.</p>
                    )}
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={this.closeLostFiles}
                    >
                      Fechar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Fragment>
    );
  }
}

export default Company;
